import React, { useEffect, useState } from "react";
import { TypeAnimation } from "react-type-animation";
import { ClockLoader } from "react-spinners";
import CategoryInfo from "./CategoryInfo";

const CategoriesInfo = () => {
   const [categoriesInfo, setCategoriesInfo] = useState([]);
   const [loading, setLoading] = useState(false);

   useEffect(() => {
      setLoading(true);
      fetch("https://recycle-hut-server.vercel.app/categories")
         .then((res) => res.json())
         .then((data) => {
            setCategoriesInfo(data);
            setLoading(false);
         });
   }, []);

   return (
      <div className="mb-[-15px] md:mb-[-5px]">
         <h1 className="uppercase text-[22px] md:text-[24px] text-cyan-500 font-bold mb-4 my-transition-4">
            <TypeAnimation
               sequence={["All Phone Categories", 3000]}
               speed={0}
               cursor={false}
               repeat={Infinity}
            />
         </h1>

         {loading ? (
            <div className="flex justify-center items-center gap-3 h-20">
               <span>
                  <ClockLoader color="#007b96" size="25" speedMultiplier="0.8" />
               </span>
               <span className="font-semibold text-[19px] text-orange-600">
                  Please Wait! Data is loading...
               </span>
            </div>
         ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-3 w-full mx-auto">
               {categoriesInfo.map((categoryInfo) => (
                  <CategoryInfo
                     key={categoryInfo._id}
                     categoryInfo={categoryInfo}
                     loading={loading}
                  ></CategoryInfo>
               ))}
            </div>
         )}
      </div>
   );
};

export default CategoriesInfo;
